import { useEffect, useRef, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import Modal from '../components/modal';

import { useTranslation } from 'react-i18next';
import bellSound from '../assets/audio/wav/bell-sound.wav';
import auxPort from '../assets/images/aux-port.png';
import bluetooth from '../assets/images/bluetooth.png';
import closed from '../assets/images/closed-default.png';
import earbuds from '../assets/images/earbuds-default.png';
import volume from '../assets/images/half-volume-yellow.png';
import headphones from '../assets/images/headphones-default.png';
import noiseCancel from '../assets/images/noisecancel.png';
import { useTestState } from '../context/TestContext';

const Device = () => {
  const audioRef = useRef<HTMLAudioElement | null>(null);
  const { state, dispatch } = useTestState();
  const navigate = useNavigate();
  const { t } = useTranslation('device');

  const [selected, setSelected] = useState(false);
  // open-ear headphones have different modal content
  const [openSelected, setOpenSelected] = useState(false);
  const [testSoundPlayed, setTestSoundPlayed] = useState(false);

  useEffect(() => {
    if (!state.contactid) {
      navigate('/demographics');
    } else {
      dispatch({ type: 'UPDATE_PROGRESS', payload: 40 });
      // we stopped paying for heap as of July 2024
      // const gaClientId = window.gaconnector2.debugData().gaClientId;
      // heap.identify(gaClientId);
      // heap.track('JHT_SUBMIT_DEMOGRAPHICS');
      // console.log('gaClientId:', gaClientId);
    }
  }, [dispatch, navigate, state.contactid]);

  const handlePlayAudio = () => {
    setTestSoundPlayed(true);
    if (audioRef && audioRef.current) {
      const playPromise = audioRef.current.play();

      if (playPromise !== undefined) {
        playPromise
          .then(() => {})
          .catch((error) => {
            if (error.name !== 'AbortError') {
              console.warn('Audio play failed:', error);
            }
          });
      }
    }
  };

  return (
    <div className="device">
      <h1 className="top-title-text">{t('title')}</h1>
      <div className="main-content">
        <button className="device-button" onClick={() => setSelected(true)}>
          <img src={closed} alt={t('closed-earbuds-alt')} />
          <p>{t('closed-earbuds')}</p>
        </button>
        <button
          className="device-button"
          onClick={() => {
            setSelected(true);
            setOpenSelected(true);
          }}
        >
          <img src={earbuds} alt={t('wireless-earbuds-alt')} />
          <p>{t('wireless-earbuds')}</p>
        </button>
        <button className="device-button" onClick={() => setSelected(true)}>
          <img src={headphones} alt={t('headphones-alt')} />
          <p>{t('headphones')}</p>
        </button>
      </div>

      <audio ref={audioRef}>
        <source src={bellSound} />
      </audio>

      {selected && (
        <Modal
          closeModal={() => {
            setSelected(false);
            setOpenSelected(false);
          }}
        >
          <div className="volume-container">
            <img src={volume} alt={t('volume-alt')} />
          </div>
          <p className="device-modal-text">{t('volume')}</p>

          {openSelected ? (
            <>
              <img
                src={bluetooth}
                alt={t('bluetooth-alt')}
                style={{ marginTop: '15px' }}
              />
              <p className="device-modal-text">{t('bluetooth')}</p>
              <img
                src={noiseCancel}
                alt={t('noise-canceling-alt')}
                style={{ marginTop: '10px' }}
              />
              <p className="device-modal-text">{t('noise-canceling')}</p>
            </>
          ) : (
            <>
              <img
                src={auxPort}
                alt={t('aux-port-alt')}
                style={{ margin: '25px 0 10px 0' }}
              />
              <p className="device-modal-text">{t('aux-port')}</p>
            </>
          )}
          <button
            onClick={() => handlePlayAudio()}
            className="link-button"
            style={{ background: 'var(--orange', marginBottom: '10px' }}
          >
            <p style={{ color: '#FFF', margin: 0 }}>{t('test-sound')}</p>
          </button>
          <p
            style={{
              fontFamily: 'Georgia',
              color: '#6F6F6F',
              width: '270px',
              textAlign: 'center',
              marginTop: '5px',
            }}
          >
            {t('make-sure')}
          </p>

          <Link
            className="link-button"
            style={{
              background: 'none',
              color: 'var(--dark-blue)',
              boxShadow: 'none',
              margin: 0,
              marginTop: '-13px',
              pointerEvents: testSoundPlayed ? 'auto' : 'none',
              opacity: testSoundPlayed ? 1 : 0.5,
            }}
            to="/environment"
            onMouseEnter={(e) => {
              if (testSoundPlayed) {
                e.currentTarget.style.opacity = '0.6';
              }
            }}
            onMouseLeave={(e) => {
              if (testSoundPlayed) {
                e.currentTarget.style.opacity = '1';
              }
            }}
          >
            Continue
          </Link>
        </Modal>
      )}
    </div>
  );
};

export default Device;
